// extracted by mini-css-extract-plugin
export var subtitle = "_cm-2";
export var title = "_cm-0";
export var titleNoWrap = "_cm-1";